import { useT } from '@/shared/lib/i18n';
import { HandKicker, PhaseTag, Pin } from '@/shared/ui';

/** Right-column placeholder shown to non-host lobby players (desktop+tablet). */
export const WaitingForHostPaper = () => {
  const t = useT();
  return (
    <div className="paper-dossier paper-ruled relative flex h-full rotate-[2deg] flex-col gap-4 px-7 py-7 text-center">
      <Pin left={28} top={-6} />
      <Pin left={'calc(100% - 28px)'} top={-6} />
      <PhaseTag size={11} color="rgba(0,0,0,.5)">
        {t('briefing.phase_00')}
      </PhaseTag>
      <HandKicker size={32} color="var(--color-magenta)" rot={-2} className="mt-2">
        {t('online.lobby.waiting_host')}
      </HandKicker>
    </div>
  );
};
